import cn from 'classnames/bind';
import React, { FC, PropsWithChildren } from 'react';
import { CSSTransition } from 'react-transition-group';
import { CSSTransitionClassNames } from 'react-transition-group/CSSTransition';

import { DEFAULT_OPACITY_TIMEOUT } from './OpacityTransitionGroup.config';
import styles from './OpacityTransitionGroup.module.css';

const cx = cn.bind(styles);

const topFadeClassName: CSSTransitionClassNames = {
    enter: cx('top-fade_enter'),
    enterActive: cx('top-fade_enter-active'),
    exit: cx('top-fade_exit'),
    exitActive: cx('top-fade_exit-active'),
    exitDone: cx('top-fade_exit-done'),
};

const bottomFadeClassName: CSSTransitionClassNames = {
    enter: cx('bottom-fade_enter'),
    enterActive: cx('bottom-fade_enter-active'),
    exit: cx('bottom-fade_exit'),
    exitActive: cx('bottom-fade_exit-active'),
    exitDone: cx('bottom-fade_exit-done'),
};

interface TransitionProps {
    isVisible?: boolean;
}

export const TopTransition: FC<PropsWithChildren<TransitionProps>> = ({ children, isVisible }) => (
    <CSSTransition
        timeout={DEFAULT_OPACITY_TIMEOUT}
        classNames={topFadeClassName}
        mountOnEnter
        in={isVisible}
    >
        {children}
    </CSSTransition>
);

export const BottomTransition: FC<PropsWithChildren<TransitionProps>> = ({
    children,
    isVisible,
}) => (
    <CSSTransition
        timeout={DEFAULT_OPACITY_TIMEOUT}
        classNames={bottomFadeClassName}
        mountOnEnter
        in={isVisible}
    >
        {children}
    </CSSTransition>
);
